module.exports = __webpack_public_path__ + "static/media/sv.c239238c.svg";